import React from "react";
import { Link } from "react-router-dom";
import "../Css/safegaurd.css";
import BannerImg from "../Img/Final-images/Safeguarding-Quality-img.png";

function SafeguardingQuality() {
  return (
    <>
      <section className="safeguardingqualit text-center mobile-view">
        <div>
          <img src={BannerImg} className="w-100" />
        </div>
        <div className="container mobile-view-none">
          <div className="breadcrumb-container" aria-label="Breadcrumb">
            <ul className="breadcrumbs">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li aria-current="page">Safeguarding & Quality</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <h3 className="sub-heading text-center mb-4">
            Safeguarding Commitment
          </h3>
          <p>
            Safeguarding is central to our culture and practice. All homes
            operate in line with
          </p>

          <ul className="quality-list mt-4">
            <li>The Children’s Homes (England) Regulations 2015</li>
            <li>Working Together to Safeguard Children</li>
            <li>The Social Care Common Inspection Framework</li>
          </ul>
          <p>
            Concerns are acted upon promptly, recorded accurately, and escalated
            in line with local safeguarding procedures.
          </p>
        </div>
      </section>

      <section className="child-rights py-5">
        <div className="container">
          {/* Heading */}
          <div className="text-center mb-5">
            <h2 className="sub-heading text-center mb-1 fw-bold mb-4">
              Promoting Children’s Rights
            </h2>
            <p className="text-center ">Children are supported to understand</p>
          </div>
          {/* Cards */}
          <div className="row g-4 justify-content-center">
            {/* Card 1 */}
            <div className="col-lg-4 col-md-6">
              <div className="rights-card h-100 text-center p-4">
                <div className="icon-circle mb-3">🏠</div>
                <h5 className="fw-semibold">
                  Their rights while living in residential care
                </h5>
              </div>
            </div>
            {/* Card 2 */}
            <div className="col-lg-4 col-md-6">
              <div className="rights-card h-100 text-center p-4">
                <div className="icon-circle mb-3">⚠️</div>
                <h5 className="fw-semibold">
                  How to raise concerns or complaints
                </h5>
              </div>
            </div>
            {/* Card 3 */}
            <div className="col-lg-4 col-md-6">
              <div className="rights-card h-100 text-center p-4">
                <div className="icon-circle mb-3">🛡️</div>
                <h5 className="fw-semibold">
                  How to access advocacy and independent support
                </h5>
              </div>
            </div>
          </div>
          {/* Bottom Info Box */}
          <div className="row mt-5">
            <div className="col-lg-10 mx-auto">
              <div className="info-box p-4 text-center">
                <p className="mb-0">
                  We encourage children to speak with trusted adults, social
                  workers, Regulation 44 visitors, Ofsted, or the Children’s
                  Commissioner.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="quality-section py-5">
        <div className="container">
          <div className="row align-items-center g-5">
            {/* Left Content */}
            <div className="col-lg-6">
              <h2 className="fw-bold mb-4">Quality Assurance</h2>
              <p className="">
                We maintain strong quality assurance systems, including:
              </p>
              <ul className="quality-list mt-4">
                <li>Regular internal audits</li>
                <li>Independent Regulation 44 visits</li>
                <li>Ongoing review of policies and practice</li>
                <li>Learning from feedback, incidents, and inspections</li>
              </ul>
              <div className="quality-note mt-4">
                Continuous improvement is embedded into our organizational
                culture.
              </div>
            </div>
            {/* Right Illustration Area */}
            <div className="col-lg-6 text-center">
              <div className="quality-card p-5">
                <div className="qa-icon mb-3">✔</div>
                <h4 className="fw-semibold">Committed to High Standards</h4>
                <p className="text-muted mb-0">
                  We monitor, review, and improve our services to ensure every
                  child receives safe, consistent and high-quality care.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default SafeguardingQuality;
